<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="close" v-on:click="close(false)"></div>
        <div class="payungB"></div>
        <div class="liCnt">
          <a :href="calUri" class="li" target="_blank">
            <div class="icon google"></div> Google Calendar
          </a>
          <a href="https://nutrilite.co.id/youthfuelsummerfest.ics" class="li" target="_blank">
            <div class="icon apple"></div> Apple Calendar
          </a>
          <a :href="calUri3" class="li" target="_blank">
            <div class="icon office"></div> Office 365
          </a>
          <a :href="calUri2" class="li" target="_blank">
            <div class="icon outlook"></div> Outlook Live
          </a>
          <a href="https://nutrilite.co.id/youthfuelsummerfest.ics" class="li" target="_blank">
            <div class="icon outlook"></div> Outlook Desktop
          </a>
          <a href="https://nutrilite.co.id/youthfuelsummerfest.ics" class="li" target="_blank">
            <div class="icon other"></div> Other Calendar
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {
    calUri() {
      const uri = 'https://calendar.google.com/calendar/u/0/r/eventedit?'
        + 'text=Youthfuel Summer Fest'
        + '&dates=20211002T030000.000Z/20211002T100000.000Z'
        + '&ctz=Asia/Jakarta'
        + '&details=Ikuti acara Youthfuel Summer Fest pada 2 Oktober 2021 di '
        + `${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        + `&location=${escape('https://nutrilite.co.id/youthfuelsummerfest/')}`
        // + '&pli=1'
        + '&uid=youthfuelsummerfest';
        // + '&sf=true'
        // + '&output=xml';
      return uri;
    },
    calUri2() {
      const uri = 'https://outlook.live.com/calendar/0/deeplink/compose?body='
        + 'Ikuti%20acara%20Youthfuel%20Summer%20Fest%20pada%202%20Oktober%20'
        + '2021%20di%20https%3A%2F%2Fnutrilite.co.id%2Fyouthfuelsummerfest%2F'
        + '&enddt=2021-10-02T22%3A00%3A00%2B00%3A00&location=https%3A%2F%2'
        + 'Fnutrilite.co.id%2Fyouthfuelsummerfest%2F&path=%2Fcalendar%2Fact'
        + 'ion%2Fcompose&rru=addevent&startdt=2021-10-02T14%3A00%3A00%2B00%'
        + '3A00&subject=Youthfuel%20Summer%20Fest';
      return uri;
    },
    calUri3() {
      const uri = 'https://outlook.office.com/calendar/0/deeplink/compose?'
        + 'body=Ikuti%20acara%20Youthfuel%20Summer%20Fest%20pada%202%20Ok'
        + 'tober%202021%20di%20https%3A%2F%2Fnutrilite.co.id%2Fyouthfuel'
        + 'summerfest%2F&enddt=2021-10-02T22%3A00%3A00%2B00%3A00&locati'
        + 'on=https%3A%2F%2Fnutrilite.co.id%2Fyouthfuelsummerfest%2F&pa'
        + 'th=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2021-'
        + '10-02T14%3A00%3A00%2B00%3A00&subject=Youthfuel%20Summer%20Fest';
      return uri;
    },
  },
  methods: {
    open(d, n) {
      this.show = true;
    },
    close(b, d) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;
    @media (max-width: 680px) {
      padding: 20px 10px;
    }
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #ffe7ea;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      overflow: hidden;
      transition: all .3s ease;
      .payungB{
        width: 160px; height: 160px;
        position: absolute;
        right: -100px; bottom: 40px;
        opacity: .6;
        background-image: url(../assets/umbrela-pink.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 7;
        // @media (max-width: 960px) {
        //   display: block;
        //   width: 240px; height: 240px;
        //   top: 50%; left: -140px; margin-top: -40px;
        // }
        // @media (max-width: 680px) {
        //   display: block;
        //   width: 140px; height: 140px;
        //   top: 50%; left: -80px; margin-top: -40px;
        // }
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      .liCnt{
        margin: 0 -100px;
        .li{
          list-style: none;
          padding: 12px 100px;
          font-size: 18px;
          cursor: pointer;
          color: #444;
          transition: all .3s ease;
          position: relative;
          display: block;
          text-decoration: none;
          @media (max-width: 680px) {
            padding: 12px 16px;
            padding-left: 80px;
          }
          .icon{
            position: absolute;
            left: 54px; top: 0; bottom: 0; width: 24px;
            background-position: center;
            background-size: 100% auto;
            background-repeat: no-repeat;
            @media (max-width: 680px) {
              left: 34px;
            }
            &.google{
              background-image: url(../assets/google.png);
            }
            &.apple{
              background-image: url(../assets/apple.png);
            }
            &.outlook{
              background-image: url(../assets/outlook.png);
            }
            &.office{
              background-image: url(../assets/office.png);
            }
            &.other{
              background-image: url(../assets/calendar.png);
            }
          }
          &:hover{
            background-color: #efd5d8;
          }
        }
      }
    }
  }
</style>
